// 製品ページのサイドバー追従（PCのみ。SPでは無効化）
import StickySidebar from 'sticky-sidebar';

let resizeTimer = null;
let sidebar = null;
const updateSidebar = () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    if (window.matchMedia('(max-width:1039px)').matches) {
      if (sidebar) {
        sidebar.destroy();
        sidebar = null;
      }
    } else if (!sidebar && document.querySelector('#sidebar')) {
      sidebar = new StickySidebar('#sidebar', {
        containerSelector: '#main-content',
        innerWrapperSelector: '.sidebar-inner',
        topSpacing: 0,
        bottomSpacing: 80,
      });
    }
  }, 500);
};

window.addEventListener('load', updateSidebar);
window.addEventListener('resize', updateSidebar);
